import {IBizPromotion, IBusiness} from "@/views/editor/service/business";
import {AEditor} from "@/views/editor/service/editor";
import {EActivityStatus, IActivityBusinessMeta} from "@/model/activity";
import {APromotion} from "@/views/editor/service/promotion/promotion";
import {CheckboxOptionType} from "ant-design-vue/es/checkbox/interface";
import {EVipLevel} from "@/model/user_agent";
import {IProduct} from "@/model/product";
import {Component} from "vue";
import FragmentFullGroups from "@/views/editor/service/promotion/tier_group/FragmentFullGroups.vue";

export interface ITierGroupProduct extends IProduct {
    regular_price: number;
    virtual_stock: number;
    images: string[];
    gifts: string[];
    tiers: ITier[];
    gifts_limit: number;
    is_detail_mode: boolean;
    pay_button_text: string;
}

export interface ITier {
    size: number;
    price: number;
    gifts: string[];
}

export interface ITierGroupMeta {
    products: ITierGroupProduct[];
    props: {
        is_show_group_list: boolean;
        is_use_group_share_thumb_image: boolean;
        goods_validity_mons: number;
        customer_phone: {
            available: boolean;
            // 报名时区分新老客
            sign: boolean,
            leader_permission: 'all' | 'old' | 'new';
            joiner_permission: 'all' | 'old' | 'new';
        };
        buy_limit: number;
        joiner_to_leader: {
            available: boolean;
            is_fill_virtual_joiner: boolean;
        };
    }
}

export default class TierGroup extends APromotion implements IBizPromotion {

    readonly opt: ITierGroupMeta

    constructor(protected readonly editor: AEditor, readonly meta: IActivityBusinessMeta) {
        super(editor, meta);
        this.opt = this.meta.setting as ITierGroupMeta
    }

    subs(status: EActivityStatus): CheckboxOptionType[] {
        return {
            active: [],
            preheating: [],
            finished: []
        }[status]
    }

    resetMeta(): IBusiness {
        if (this.editor.userAgent.authorizer().grant(EVipLevel.Professional))
            this.editor.biz.active.coupon?.set('tier_group', [])

        const opt: ITierGroupMeta = {
            products: [this.emptyProduct()],
            props: {
                is_show_group_list: true,
                is_use_group_share_thumb_image: false,
                goods_validity_mons: 3,
                customer_phone: {
                    available: false,
                    sign: false,
                    leader_permission: 'all',
                    joiner_permission: 'all'
                },
                buy_limit: 0,
                joiner_to_leader: {
                    available: false,
                    is_fill_virtual_joiner: false
                },
            }
        }
        Object.assign(this.opt, opt)
        return this;
    }

    price(): number {
        return this.opt.products.reduce((sum, product) => sum = sum > product.price ? sum : product.price, 0);
    }

    emptyProduct: () => ITierGroupProduct = () => ({
        gifts: [],
        gifts_limit: 0,
        images: [],
        is_detail_mode: false,
        name: "在这里填写商品描述",
        origin_price: 200,
        pay_button_text: "立即开团",
        price: 100,
        regular_price: 0,
        stock: 500,
        thumbnail: 'https://static.pms.guandb.cn/media/system/console/20260302195412.jpg',
        tiers: [{size: 0, price: 100, gifts: []}, {size: 2, price: 100, gifts: []}],
        virtual_stock: 0,
    })

    lookersListView(): { title: string, component: Component } {
        return {title: '满团记录', component: FragmentFullGroups}
    }
}